import { AbstractControl } from '@angular/forms';
import { calculateAge, dobRegex } from './util';

export default function atLeastAge(minAge) {
  return (control: AbstractControl) => {
    if (control && control.value) {
      if (dobRegex.test(control.value)) {
        const calcAge = calculateAge(control.value);
        if (calcAge < minAge) {
          return {
            atLeastAge: true,
          };
        }
      }
    }
    return null;
  };
}
